export const copyrightText = '© traplinked 2023'
export const contactEmail = 'kontakt@traplinked.com'
